export class Controller {

    /** @ngInject */
    constructor($rootScope, $uibModal, UserPhoneNumber) {
        this.$rootScope = $rootScope;
        this.UserPhoneNumber = UserPhoneNumber;
        this.$uibModal = $uibModal;
    }

    $onInit() {
        this.phoneNumber = '';
    }

    save() {
        this.UserPhoneNumber.save(
            {
                phoneNumber: this.phoneNumber,
                usedForRecovery: false,
                smsNumber: false,
            },
            (value, responseHeaders) => {
                const id = responseHeaders('Location').split('/')[4];
                this.UserPhoneNumber
                    .get({id}).$promise
                    .then((phoneNumber) => {
                        this.$uibModal
                            .open({
                                component: 'verifyPhoneNumber',
                                resolve: {phoneNumber: () => phoneNumber}
                            }).result
                            .finally(() => this.close());
                    });
            },
            (response) => {
                this.dismiss();
            },
        );
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/add/add-phone-number.controller.js